import { Loader2 } from 'lucide-react'
import { Cell } from '@highlight/ui'

export interface StagedActionLoadingProps {
  actionType?: string
}

function getActionLabel(actionType?: string) {
  switch (actionType) {
    case 'sendSlackMessage':
      return 'Slack message'
    case 'createLinearTicket':
      return 'Linear ticket'
    case 'createNotionPage':
      return 'Notion page'
    default:
      return 'action'
  }
}

export function StagedActionLoading({ actionType }: StagedActionLoadingProps) {
  return (
    <Cell isPending clickable={false}>
      <Cell.Header showChevron={false}>
        <Cell.Icon>
          <Loader2 className="text-foreground-placeholder size-3 animate-spin" />
        </Cell.Icon>
        <Cell.Title>{`Creating ${getActionLabel(actionType)}...`}</Cell.Title>
      </Cell.Header>
    </Cell>
  )
}
